import { useEffect, useCallback } from 'react';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import {
  ALERT_FETCH_ALERT_SETS_BEGIN,
  ALERT_FETCH_ALERT_SETS_SUCCESS,
  ALERT_FETCH_ALERT_SETS_FAILURE,
  ALERT_FETCH_ALERT_SETS_DISMISS_ERROR,
} from './constants';
import { serviceFind } from '../../../common/feathers'

export const fetchAlertSets = serviceFind('alertSets', {
  begin: ALERT_FETCH_ALERT_SETS_BEGIN,
  success: ALERT_FETCH_ALERT_SETS_SUCCESS,
  fail: ALERT_FETCH_ALERT_SETS_FAILURE
})

export function dismissFetchAlertSetsError() {
  return {
    type: ALERT_FETCH_ALERT_SETS_DISMISS_ERROR,
  };
}

export function useFetchAlertSets() {
  const dispatch = useDispatch();

  const { fetchAlertSetsPending, fetchAlertSetsError, alertSets } = useSelector(
    state => ({
      fetchAlertSetsPending: state.alert.fetchAlertSetsPending,
      fetchAlertSetsError: state.alert.fetchAlertSetsError,
      alertSets: state.alert.alertSets,
    }),
    shallowEqual,
  );

  const boundAction = useCallback((...args) => {
    return dispatch(fetchAlertSets(...args));
  }, [dispatch]);

  const boundDismissError = useCallback(() => {
    return dispatch(dismissFetchAlertSetsError());
  }, [dispatch]);

  return {
    fetchAlertSets: boundAction,
    fetchAlertSetsPending,
    fetchAlertSetsError,
    alertSets,
    dismissFetchAlertSetsError: boundDismissError,
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case ALERT_FETCH_ALERT_SETS_BEGIN:
      // Just after a request is sent
      return {
        ...state,
        fetchAlertSetsPending: true,
        fetchAlertSetsError: null,
      };

    case ALERT_FETCH_ALERT_SETS_SUCCESS:
      // The request is success
      return {
        ...state,
        fetchAlertSetsPending: false,
        fetchAlertSetsError: null,
        alertSets: action.data,
      };

    case ALERT_FETCH_ALERT_SETS_FAILURE:
      // The request is failed
      return {
        ...state,
        fetchAlertSetsPending: false,
        fetchAlertSetsError: action.data.error,
      };

    case ALERT_FETCH_ALERT_SETS_DISMISS_ERROR:
      // Dismiss the request failure error
      return {
        ...state,
        fetchAlertSetsError: null,
      };

    default:
      return state;
  }
}
